<div class="content-wrapper">
    <div class="content-body">


        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <div class="row">
            <button type="button" class="btn btn-outline-success ml-1 mb-1"
                *ngIf="transaction?.kindId == 5 && quoteCode.isExpired"
                (click)="updateTransactionStatus(transaction?.id,6,5)">
                <i data-feather="check"></i> Siparişe Çevir
            </button>
            <button type="button" class="btn btn-outline-danger ml-1 mb-1"
                *ngIf="!(transaction?.status === 4 && transaction?.kindId === 5) && !(transaction?.kindId === 6) && quoteCode.isExpired"
                (click)="updateTransactionStatus(transaction?.id, transaction?.kindId, 4)">
                <i data-feather="x"></i> Teklifi Reddet
            </button>

            <div class="d-flex">
                <p class="ml-5" style="text-align: center;">
                    <strong>Kod geçerlilik süresi:{{quoteCode.expiry | date:'HH:mm:SS' }}</strong>
                </p>
                <p class="ml-5">
                    <strong>Kalan Süre {{ remainingTime | date: 'mm:ss' }}</strong>
                </p>
            </div>

        </div>

        <div class="card">
            <div class="card-body">

                <div class="row">
                    <div class="col-xl-8 col-md-6 col-12">
                        <p><strong>Şirket Adı:</strong></p>
                        <h5 class="card-title">

                            {{ transaction?.companyName }}

                        </h5>
                    </div>
                    <div class="col-xl-4 col-md-12">
                        <div class="d-flex">
                            <div class="status-badge" [ngClass]="getStatusClass(transaction?.status)">
                                {{ getStatusText(transaction?.status,transaction?.kindId) }}
                            </div>
                            <div class="ml-2 badge badge-secondary  status-badge-2" *ngIf="transaction?.docNo">
                                <strong>Teklif No:</strong> {{ transaction?.docNo }}
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Tarih ve Diğer Bilgiler -->
                <div class="row">
                    <div class="col-xl-2 col-md-6 col-sm-12">
                        <strong>Oluşturulma Tarihi:</strong>
                        <p>{{ transaction?.transactionCraetedAt | date:'dd/MM/yyyy' }}</p>
                    </div>
                    <div class="col-xl-2 col-md-6 col-sm-12">
                        <strong>Bitiş Tarihi:</strong>
                        <p>{{ transaction?.validityDate | date:'dd/MM/yyyy' }}</p>
                    </div>
                    <div class="col-xl-3 col-md-6 col-sm-12">
                        <p><strong>Bağlı Olduğu Talep:</strong></p>
                        <p>{{ transaction?.requestTaskTitle }}</p>
                    </div>
                    <div class="col-xl-3 col-md-6 col-sm-12" *ngIf="transaction?.project">
                        <p class="mb-0"><strong>Bağlı Olduğu Proje:</strong></p>
                        <p class="mb-0">{{ transaction?.project }}</p>
                    </div>
                    <div class="col-xl-2 col-md-6 col-sm-12" *ngIf="transaction?.personName">
                        <p>
                            <strong>Firma Sorumlu Kişi:</strong>
                        </p>
                        <p>{{ transaction?.personName }} {{
                            transaction?.personLastName }}</p>
                    </div>
                </div>

                <!-- Ekstra Bilgiler ve Durum -->
                <div class="row" *ngIf="transaction?.transactionPrivateNode">
                    <div class="col-xl-8 col-md-12">
                        <div class="d-flex align-items-center">
                            <p>
                                <strong>Teklif Gizli Not:</strong> {{ transaction?.transactionPrivateNode }}
                            </p>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-body">
        <div class="col-12 mb-2">

            <div class="button-group">

                <button type="button" class="btn btn-icon btn-outline-warning" rippleEffect
                    (click)="isPrivateDiscountToogle()">
                    <span data-feather="trending-down"></span>
                </button>

            </div>
        </div>

        <div>
            <table class="table table-responsive">
                <thead>
                    <tr>
                        <th style="width: 50%;">Ürün Adı</th>
                        <th>Miktar</th>
                        <th>Birim Fiyatı</th>
                        <th *ngIf="isDiscount">İndirim</th>
                        <th *ngIf="isDiscount">Ara Toplam</th>
                        <th>Net</th>
                        <th>KDV</th>
                        <th>V.D Toplam</th>
                        <th>#</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let transaction of transactionList; let i = index">
                        <td style="width: 50%;"><a
                                (click)="showUpdateTransaction(transaction?.transactionManagemetnProductId)"
                                style="font-weight: bold; color: rgb(0, 89, 255);">{{
                                transaction?.productName }}</a><br><span class="description">{{
                                transaction.description }}</span></td>

                        <td>{{ transaction.productCount }}</td>

                        <td>{{ transaction.productPrice }}</td>
                        <td *ngIf="isDiscount">{{transaction.discountRate}}</td>
                        <td *ngIf="isDiscount">{{transaction.productCount * transaction.productPrice | number:'1.1-2' }}
                        </td>
                        <td>{{(transaction.productCount * transaction.productPrice)-((transaction.productCount *
                            transaction.productPrice) * transaction.discountRate / 100 ) | number:'1.1-2' }}</td>
                        <td>(%{{transaction.taxRate }})</td>
                        <td>
                            {{
                            (((transaction.productCount * transaction.productPrice) -
                            ((transaction.productCount * transaction.productPrice) * transaction.discountRate /
                            100))) +
                            ((((transaction.productCount * transaction.productPrice) -
                            ((transaction.productCount * transaction.productPrice) * transaction.discountRate /
                            100)) *
                            transaction.taxRate) / 100)
                            | number:'1.1-2'}}
                        </td>

                        <td>
                            <div class="button-container">
                                <button class="btn btn-icon btn-icon rounded-circle btn-flat-danger"
                                    (click)="deleteTransaction(transaction.transactionManagemetnProductId)">
                                    <i data-feather="x"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="totalAmount !== null">
                        <td colspan="9" style="text-align: right;">
                            <div>
                                <strong>Toplam Miktar: </strong><strong class="ml-1">{{ sumCount() | number:'1.1-2' }}</strong>
                            </div>
                            <div>
                                <strong>Brüt Toplam: </strong><strong class="ml-1">{{ sumGross() | number:'1.1-2' }}</strong>
                            </div>
                            <div>
                                <strong>Toplam İndirim: </strong><strong class="ml-1">{{ sumDiscount() | number:'1.1-2'
                                    }}</strong>
                            </div>
                            <div>
                                <strong>Net Toplam: </strong><strong class="ml-1">{{ sumNetTotal() | number:'1.1-2' }}</strong>
                            </div>
                            <div *ngFor="let item of transactionDiscountTotal" style="text-align: right;">
                                <strong>KDV Toplam %({{ item.taxRate }}): {{ item.totalTax }}</strong>
                            </div>
                            <div>
                                <strong>Genel Toplam: </strong><strong class="ml-1">{{ calculateGeneralTotal() | number:'1.1-2'
                                    }}</strong>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>